import { Layout, Row, Col, Card, Select, Button } from 'antd'; // Import's Ant Design 
import React, { useState, useEffect } from 'react'; // Import's React 
import BarChart from './charts/BarChart'; // Import BarChart

const { Content, Header } = Layout // Destructuring Layout
const { Option } = Select; // Destructuring Select

const YearStatistics = () => {

  /* -------------------- Hooks State -------------------- */
  const [group, setGroup] = useState('');


  /* -------------------- Return -------------------- */
  return (
    // Graphics Container
    <Content>
      {/* Header */}
      <Header 
        style={{ background: 'white', width: '100%', borderRadius: '5px', marginBottom: '1.5rem', boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)' }}>
        <div 
          style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '5px' }}>
          {/* Header Select */}
          <div
            style={{ width: '20%', textAlign: 'center' }}>
            <Select
              defaultValue="Selecciona una opción"
              style={{ width: 200 }}
              onChange={e => setGroup(e)}>
              <Option
                value="honda">Grupo - Honda
              </Option>
              <Option
                value="kia">Grupo - Kia
              </Option>
            </Select>
          </div>
          {/* Header Año | Mes */}
          <div 
            style={{ width: '20%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px'}}>
            <Button 
              type='primary'>Año
            </Button>  
            <Button 
              type='primary'>Mes
            </Button>
          </div>
          {/* Header Año */}
          <div 
            style={{ width: '20%', textAlign: 'center' }}>
            Agosto 2022
          </div>
        </div>
      </Header>

      {/* Graphics */}
      <Row>
        <Col 
          span={12} 
          style={{ borderRadius: '5px', margin: '0 auto' }}>
          <Card
            size="small"
            title=""
            style={{
              width: '100%',
              boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)'
            }}
          >
            <BarChart 
              group = {group}
            />
          </Card>
        </Col>
      </Row>
    </Content >
  )
}

export default YearStatistics